import { render, staticRenderFns } from "./Ccrk.vue?vue&type=template&id=6b3f231a&scoped=true&"
import script from "./Ccrk.vue?vue&type=script&lang=js&"
export * from "./Ccrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f231a",
  null
  
)

export default component.exports